import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNinkasi = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 152.126 22.222",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fill: "currentColor",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "m159.108 65.857c-.992-1.865-1.506-2.832-3.187-5.8l-4.6-7.82h-5.2v21.226h5.079l-.154-13.357a74.409 74.409 0 0 0 3.737 6.65l3.967 6.707h5.2v-21.229h-5.082z",
				fillRule: "evenodd",
				transform: "translate(-146.116 -51.72)"
			}),
			/* @__PURE__ */ _jsx("path", { d: "m27.394.513h5.292v21.229h-5.292z" }),
			/* @__PURE__ */ _jsxs("g", {
				fillRule: "evenodd",
				children: [
					/* @__PURE__ */ _jsx("path", {
						d: "m278.194 65.857c-.992-1.865-1.5-2.832-3.186-5.8l-4.6-7.82h-5.2v21.226h5.081l-.15-13.357a74.444 74.444 0 0 0 3.728 6.65l3.969 6.707h5.2v-21.229h-5.083z",
						transform: "translate(-222.926 -51.72)"
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "m361.817 52.234h-6.372l-7.94 8.659v-8.659h-5.049v21.229h5.044v-6.223l3.253-3.4 5.683 9.618h5.98l-8.116-13.352z",
						transform: "translate(-272.751 -51.72)"
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "m416.311 52.234-7.879 21.229h5.655l1.054-3.4h7.815l1.056 3.4h5.655l-7.82-21.229zm.06 14.009c.482-1.589 1.294-4.086 1.751-5.683.3-1.08.6-2.2.866-3.273l2.768 8.955z",
						transform: "translate(-315.305 -51.72)"
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "m496.777 60.44a41.325 41.325 0 0 0 -6.494-1.267c-.9-.119-2.712-.352-2.712-1.975 0-1.023 1.054-2.232 3.163-2.232a7.594 7.594 0 0 1 3.458.934 9.781 9.781 0 0 1 2.106 1.714l3.908-2.794c-1.833-1.657-4.482-4.033-9.385-4.033-3.662 0-8.536 1.623-8.536 7.1 0 4.57 4.419 5.5 5.709 5.776 1.145.24 2.319.386 3.493.539 1.563.214 3.7.477 3.7 2.163 0 1.481-1.808 2.467-3.916 2.467a8.713 8.713 0 0 1 -4.088-1.019 6.753 6.753 0 0 1 -2.044-1.657l-4.03 2.553c1.323 1.54 3.7 4.3 9.689 4.3 2.972 0 6.039-.629 7.961-2.856a7.077 7.077 0 0 0 1.687-4.51 5.26 5.26 0 0 0 -3.671-5.2",
						transform: "translate(-362.182 -50.787)"
					})
				]
			}),
			/* @__PURE__ */ _jsx("path", { d: "m146.83.514h5.296v21.229h-5.296z" })
		]
	})
});
export default SvgNinkasi;
